export default {
	"fbbcd10d1f1e730217a0d22f496ae915": "跳转客服失败",
	"e3a203abb5cfd142073e1808281c64b0": "取消",
	"1120daef6b846405d5c2ddcb17368afd": "联系客服"
}
